import OurTeam from "./sections/ourTeam/OurTeam";
import { Box } from "@mui/material";
import ContactUsSection from "./sections/contact-us/ContactUsSection";
import YourJourneyWithUs from "./sections/yourJourneyWithUs/YourJourneyWithUs";
import Banner from "./sections/banner/Banner";
import WhatWeOffer from "./sections/whatWeOffer/WhatWeOffer";
import Testimonial from "./sections/testimonial/Testimonial";
import { useEffect } from "react";
import { PageTitle } from "../constants/constants";
import WhyChooseUs from "./sections/whyChooseUs/WhyChooseUs";

const Home = () => {
  useEffect(() => {
    window.document.title = PageTitle.HOME;
  }, []);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",

        textShadow: "",
      }}
    >
      <Box>
        <Banner />
      </Box>
      <Box>
        <WhatWeOffer />
      </Box>
      <Box
        sx={{
          marginTop: "20px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box sx={{ width: "100%" }}>
          <YourJourneyWithUs />
        </Box>
      </Box>

      <Box
        sx={{
          marginTop: "20px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box sx={{ width: "100%" }}>
          <WhyChooseUs />
        </Box>
      </Box>
      <Box>
        <OurTeam />
      </Box>
      <Box>
        <Testimonial />
      </Box>
      <Box>
        <ContactUsSection />
      </Box>
    </Box>
  );
};

export default Home;

//Banner -- last
//Services --
//How We work
//Why chooses Us
//Out Team
//Testomonials
//Contact US
//Footer
